"use client";
import { Clock, Fingerprint, Maximize, Layers } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { problem as data } from "@/lib/data/platform-dashboard";

const iconMap: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = {
  Clock, Fingerprint, Maximize, Layers,
};
const accents = ["var(--color-amber)", "var(--color-cyan)", "var(--color-purple)", "var(--color-emerald)"] as const;

export function Problem() {
  return (
    <Section id="problem" className="relative">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute top-1/3 right-1/4 h-72 w-72 rounded-full bg-[var(--color-amber)] opacity-15 blur-[120px]" />
      </div>
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-amber)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          {data.pillars.map((p, i) => {
            const Icon = iconMap[p.icon] ?? Clock;
            const accent = accents[i % accents.length]!;
            return (
              <Reveal key={p.title} delay={i * 80}>
                <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)` }}>
                  <span
                    className="grid place-items-center h-11 w-11 rounded-xl"
                    style={{
                      background: `color-mix(in oklch, ${accent} 18%, transparent)`,
                      boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)`,
                    }}
                  >
                    <Icon className="h-5 w-5" style={{ color: accent }} />
                  </span>
                  <h3 className="mt-4 text-lg">{p.title}</h3>
                  <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{p.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}
